import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import Modal from "react-modal";
import PopUp from "../../../componente/popup/index.jsx";
import { useAppContext } from '../../../context/AppContext.js';

function OpeAjustePonto() {
    const { DateTime } = require("luxon");
    const [lista, setlista] = useState([]);
    const [listacolaborador, setlistacolaborador] = useState([]);
    const [abusca, setabusca] = useState("");
    const [showform, setshowform] = useState(false);

    const [edtcodhumor, setedtcodhumor] = useState(0);
    const [edttipohumor, setedttipohumor] = useState("");
    const [edtmomento, setedtmomento] = useState("");
    const [edtdtlancamento, setedtdtlancamento] = useState("");
    const [edtcodcolaborador, setedtcodcolaborador] = useState(0);
    const [edtjustificativa, setedtjustificativa] = useState("");

    const [novo, setnovo] = useState(false);

    const [isOpen, setIsOpen] = useState(false);

    const { codassinante, selectedCompany, accessKey } = useAppContext();

    const dt = new Date();

    const date1 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const date2 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const [dt1, setdt1] = useState(date1);
    const [dt2, setdt2] = useState(date2);

    const handleOpen = (cad) => {
        setedtcodhumor(cad.codhumor);
        setIsOpen(true);
    };

    const handleConfirma = () => {
        setIsOpen(false);
        Excluir();
    };

    const handleClose = () => {
        setIsOpen(false);
    };

    function ListarHumor() {

        api
            .get("/v1/operacoes/ajusteponto", {
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1,
                    dt2
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarHumor();
        },
        [showform, abusca, selectedCompany, dt1, dt2]
    );

    function ListarColaborador() {
        api
            .get("v1/cadastro/colaborador", {
                params: {
                    busca: "",
                    codassinante,
                    codempresa: selectedCompany
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlistacolaborador(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Cadastrar() {
        api
            .post(
                "/v1/operacoes/ajusteponto",
                {
                    tipohumor: edttipohumor,
                    momento: edtmomento,
                    dtlancamento: edtdtlancamento,
                    codcolaborador: edtcodcolaborador,
                    excluido: "N",
                    codassinante,
                    codempresa: selectedCompany,
                    justificativa: edtjustificativa
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarHumor();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Editar() {
        api
            .put(
                "/v1/operacoes/ajusteponto",
                {
                    tipohumor: edttipohumor,
                    momento: edtmomento,
                    dtlancamento: edtdtlancamento,
                    codcolaborador: edtcodcolaborador,
                    excluido: "N",
                    codassinante,
                    codempresa: selectedCompany,
                    codhumor: edtcodhumor,
                    justificativa: edtjustificativa
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessKey}`,
                    },
                }
            )
            .then(() => {
                ListarHumor();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Excluir() {
        api
            .delete("/v1/operacoes/ajusteponto", {
                params: {
                    codhumor: edtcodhumor
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(() => {
                ListarHumor();
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    function Salvar() {
        novo ? Cadastrar() : Editar();
        setshowform(false);
    }

    function closeModal() {
        setshowform(false);
    }

    function openModalNovo() {
        setshowform(true);
        setnovo(true);

        setedtcodhumor(0);
        setedttipohumor("");
        setedtmomento("E");
        const dt = new Date();
        const date =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        let time =
            dt.getHours().toString().padStart(2, "0") +
            ":" +
            dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        setedtdtlancamento(dtcadastro);
        setedtcodcolaborador(0);
        setedtjustificativa("");

        ListarColaborador();
    }

    function openModalEditar(cad) {
        setshowform(true);
        setnovo(false);

        setedtcodhumor(cad.codhumor);
        setedttipohumor(cad.tipohumor);
        setedtmomento(cad.momento);
        const dt = DateTime.fromISO(cad.dtlancamento)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd HH:mm");

        setedtdtlancamento(dt);
        setedtcodcolaborador(cad.codcolaborador);
        setedtjustificativa(cad.justificativa);

        ListarColaborador();
    }

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    const handleColaboradorChange = (event) => {
        setedtcodcolaborador(event.target.value); // Armazena "null" para todas as empresas
    };

    const handleTipoHumorChange = (event) => {
        setedttipohumor(event.target.value); // Armazena "null" para todas as empresas
    };

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div>
                        <div>
                            <PopUp isOpen={isOpen} onClose={handleClose}>
                                <h2>Verificação</h2>
                                <p>Tem certeza que deseja excluir esse registro?</p>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button
                                            className="btn btn-primary me-2"
                                            onClick={handleConfirma}
                                        >
                                            Sim
                                        </button>
                                        <button className="btn btn-danger" onClick={handleClose}>
                                            Não
                                        </button>
                                    </div>
                                </div>
                            </PopUp>
                        </div>

                        <Modal
                            isOpen={showform}
                            onRequestClose={closeModal}
                            overlayClassName="modal-overlay"
                            className="modal-content"
                        >
                            <div className="container-fluid h-100">
                                <div className="row">
                                    <h2>Novo Cadastro</h2>
                                </div>
                                <div className="row">
                                    <hr />
                                </div>

                                <div className="row">
                                    <form>
                                        <div className="row">
                                            <div className="col-sm-3">
                                                <label htmlFor="dtlancamento" className="form-label">
                                                    Dt. Lançamento
                                                </label>
                                                <input
                                                    type="datetime-local"
                                                    id="dtlancamento"
                                                    className="form-control"
                                                    placeholder="Dt. Lançamento"
                                                    value={edtdtlancamento}
                                                    onChange={(e) => setedtdtlancamento(e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-2">
                                                <div>
                                                    <label htmlFor="momento" className="form-label">
                                                        Momento
                                                    </label>
                                                    <br />
                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="momento"
                                                            value="E"
                                                            onChange={(e) => setedtmomento(e.target.value)}
                                                            checked={edtmomento === "E"}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            for="inlineRadio1"
                                                        >
                                                            Entrada
                                                        </label>
                                                    </div>

                                                    <div className="form-check form-check-inline">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="momento"
                                                            value="S"
                                                            onChange={(e) => setedtmomento(e.target.value)}
                                                            checked={edtmomento === "S"}
                                                        />
                                                        <label className="form-check-label" htmlfor="momento2">
                                                            Saída
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-5">
                                                <label htmlFor="colaborador" className="form-label">
                                                    Profissional
                                                </label>
                                                <select className="form-select" value={edtcodcolaborador || '0'} onChange={handleColaboradorChange}>
                                                    <option value="0">Selecione o profissional</option>
                                                    {listacolaborador.map((col, index) => (
                                                        <option key={index} value={col.codcolaborador}>{col.nome}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-sm-5">
                                                <label htmlFor="tipohumor" className="form-label">
                                                    Tipo de Humor
                                                </label>
                                                <select className="form-select" value={edttipohumor || '0'} onChange={handleTipoHumorChange}>
                                                    <option value="0">Selecione o humor</option>
                                                    <option value="Tô eufórico/vibrante">Tô eufórico/vibrante</option>
                                                    <option value="Tô incrível/maravilhoso(a)">Tô incrível/maravilhoso(a)</option>
                                                    <option value="Tô alegre">Tô alegre</option>
                                                    <option value="Tô bem">Tô bem</option>
                                                    <option value="Tô neutro/indiferente">Tô neutro/indiferente</option>
                                                    <option value="Tô triste">Tô triste</option>
                                                    <option value="Tô ansioso(a)">Tô ansioso(a)</option>
                                                    <option value="Tô com medo">Tô com medo</option>
                                                    <option value="Tô com raiva">Tô com raiva</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                                <label htmlFor="justificativa" className="form-label">
                                                    Justificativa
                                                </label>
                                                <input
                                                    type="text"
                                                    id="justificativa"
                                                    className="form-control"
                                                    placeholder="Justificativa"
                                                    value={edtjustificativa}
                                                    onChange={(e) => setedtjustificativa(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                <div className="row">
                                    <div className="col-12 mt-3 d-flex justify-content-end">
                                        <button className="btn btn-danger ms-4" onClick={closeModal}>
                                            Cancelar
                                        </button>
                                        <button className="btn btn-success ms-4" onClick={Salvar}>
                                            Salvar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>

                    <div className="row">
                        <h1 className="ms-4">Ajuste de Ponto</h1>
                        <p className="ms-4">Rotina para manutenção dos pontos dos profissionais da Empresa</p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <label className="d-block" htmlFor="busca">
                                Busque aqui
                            </label>
                            <input
                                type="text"
                                placeholder="Buscar por: Código ou nome do profissional"
                                name="busca"
                                id="busca"
                                className="form-control me-3"
                                value={abusca}
                                onChange={(e) => setabusca(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-3">
                            <label htmlFor="dtlancamento" className="form-label">
                                Lançamento de
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt1}
                                onChange={(e) => setdt1(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-3">
                            <label htmlFor="dtlancamento" className="form-label">
                                Para...
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt2}
                                onChange={(e) => setdt2(e.target.value)}
                            />
                        </div>

                        <div className="col-2 d-flex justify-content-center">
                            <button
                                className="btn btn-success btnnovo"
                                onClick={() => openModalNovo()}
                            >
                                Novo
                            </button>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Dt. Lançamento</th>
                                    <th>Momento</th>
                                    <th>Nome</th>
                                    <th>Tipo de Humor</th>
                                    <th>Justificativa</th>
                                    <th className="acao">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item) {
                                    return (
                                        <tr key={item.codhumor}>
                                            <th>{FormataDataHora(item.dtlancamento)}</th>
                                            <th>{item.momento1}</th>
                                            <th>{item.nome}</th>
                                            <th>{item.tipohumor}</th>
                                            <th>{item.justificativa}</th>
                                            <th>
                                                <div className="d-flex justify-content-center">
                                                    {item.solicitacao === 'S' && <button className="btn fa-solid fa-question" disabled />}
                                                    <button
                                                        className="btn fa-regular fa-pen-to-square"
                                                        onClick={() => openModalEditar(item)}
                                                    ></button>
                                                    <button
                                                        className="btn fa-solid fa-trash"
                                                        onClick={() => handleOpen(item)}
                                                    ></button>
                                                </div>
                                            </th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OpeAjustePonto;
